<template>
    <div class="tender-table">
        <div class="label-wrap">
            <div
                class="label-item"
                :class="{ active: currentType === tabs[0].type }"
                @click="handleTabClick(0)"
            >
                <div>
                    <span class="text">已报名待购标书</span>
                    <span class="value">{{ tenderInfo.pendingTender }}</span>
                </div>
                <div class="detail" @click.stop="handleLink(tabs[0].pageParams)">
                    <span>详情</span>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div
                class="label-item"
                :class="{ active: currentType === tabs[1].type }"
                @click="handleTabClick(1)"
            >
                <div>
                    <span class="text">待缴纳投标保证金</span>
                    <span class="value">{{ tenderInfo.bidPaid }}</span>
                </div>
                <div class="detail" @click.stop="handleLink(tabs[1].pageParams)">
                    <span>详情</span>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div
                class="label-item"
                :class="{ active: currentType === tabs[2].type }"
                @click="handleTabClick(2)"
            >
                <div>
                    <span class="text">待盖章应标文件</span>
                    <span class="value">{{ tenderInfo.sealedQuotation }}</span>
                </div>
                <div class="detail" @click.stop="handleLink(tabs[2].pageParams)">
                    <span>详情</span>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div
                class="label-item"
                :class="{ active: currentType === tabs[3].type }"
                @click="handleTabClick(3)"
            >
                <div>
                    <span class="text">待报价</span>
                    <span class="value">{{ tenderInfo.toQuote }}</span>
                </div>
                <div class="detail" @click.stop="handleLink(tabs[3].pageParams)">
                    <span>详情</span>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </div>
        <el-table
            max-height="495"
            :data="tableData"
            style="width: 100%"
            v-loading="loading"
        >
            <el-table-column prop="bidNo" label="招标项目编码" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="bidName" label="招标项目名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="depositEndTime" label="保证金提交截止时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="100px">
                <template slot-scope="{ row }">
                    <el-button
                        class="bigData-btn-td-vi"
                        type="text"
                        @click="
                            viewPage(row)
                        "
                        >去查看</el-button
                    >
                </template>
            </el-table-column>

            <div slot="empty">
                <img class="img" src="./img/table-empty.png" alt="" />
                <div class="empty-text">暂无数据</div>
            </div>
        </el-table>
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { bidHomePage, getTenderInfo } from "../manageDesk/manageDaskApi.js";

const tabs = [
    {
        type: 1,
        pageParams: {
            path: '/lsrm/myBidding',
            query: {
                supplierBidStatus: '2',
                bidStatus: '30'
            }
        },
    },
    {
        type: 2,
        pageParams: {
            path: '/lsrm/myBidding',
            query: {
                supplierBidStatus: '3',
                bidStatus: '30'
            }
        },
    },
    {
        type: 3,
        pageParams: {
            path: '/lsrm/myBidding',
            query: {
                supplierBidStatus: '11',
                bidStatus: '30'
            }
        },
    },
    {
        type: 4,
        pageParams: {
            path: '/lsrm/myBidding',
            query: {
                bidStatus: '50'
            }
        },
    },
]

export default {
    inject: ['linkToPointPage'],
    data() {
        return {
            tabs,
            currentType: tabs[0].type,
            tenderInfo: {
                pendingTender: '-',
                bidPaid: '-',
                sealedQuotation: '-',
                toQuote: '-',
            },
            tableData: [],
            pageSize: 10,
            pageNo: 1,
            total: 0,
            loading: false
        };
    },
    computed: {
        ...mapGetters(['supplier', 'btnPermissions'])
    },
    methods: {
        handleLink(pageParams) {
            this.linkToPointPage && this.linkToPointPage(pageParams)
        },
        handleTabClick(index) {
            this.currentType = this.tabs[index].type
            this.pageNo = 1
            this.getData()
        },
        viewPage(row) {
            const pageParams = {
                path: '/lsrm/myBidding',
                query: {
                    noticeCode: row.bidNo
                },
            }
            this.linkToPointPage && this.linkToPointPage(pageParams)
        },
        handleSizeChange(v) {
            this.pageSize = v;
            this.pageNo = 1;
            this.getData();
        },
        handleCurrentChange(v) {
            this.pageNo = v;
            this.getData();
        },
        getInfo() {
            getTenderInfo(this.supplier.supplierCode).then(res => {
                if (res && +res.code === 0) {
                    this.tenderInfo.pendingTender = res.data.pendingTender
                    this.tenderInfo.bidPaid = res.data.bidPaid
                    this.tenderInfo.sealedQuotation = res.data.sealedQuotation
                    this.tenderInfo.toQuote = res.data.toQuote
                    this.$emit('count',
                        Number(res.data.pendingTender) + Number(res.data.bidPaid) +
                        Number(res.data.sealedQuotation) + Number(res.data.toQuote)
                    )
                }
            })
        },
        getList() {
            const pramas = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                type: this.currentType,
                supplierCode: this.supplier.supplierCode
            };
            this.loading = true;
            bidHomePage(pramas)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { list, totalCount } = res.data;
                        this.total = totalCount || 0;
                        this.tableData = list;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getData() {
            if (this.btnPermissions.includes('/storeWorkbench-70')) {
                this.getInfo()
                this.getList()
            } else {
                this.tenderInfo.pendingTender = 0
                this.tenderInfo.bidPaid = 0
                this.tenderInfo.sealedQuotation = 0
                this.tenderInfo.toQuote = 0
            }
        }
    },
    mounted() {
        // this.getData()
    }
};
</script>
<style lang="less" scoped>
.tender-table {
    .label-wrap {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .label-item {
            flex: 1;
            height: 32px;
            border-radius: 2px;
            margin-right: 16px;
            padding-left: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            cursor: pointer;
            &:last-child {
                margin-right: 0;
            }
            .text {
                color: #4e5969;
            }
            .value {
                margin-left: 8px;
                font-weight: 600;
                color: #1d2129;
            }
            .detail {
                padding: 8px 12px;
                color: #2881FF;
                display: none;
            }
            .el-icon-arrow-right {
                padding-left: 10px;
            }

            &.active, &:hover {
                background: #f7f8fa;

                .detail {
                    display: block;
                }
            }
        }
    }
    /deep/ .el-table {
        .cell {
            line-height: 34px;
        }
        th {
            background-color: #f2f3f5;
        }
        .el-table__empty-block {
            min-height: 170px;
            font-size: 14px;
            color: #4e5969;
            .img {
                width: 110px;
                height: 80px;
                display: block;
                margin: 0 auto;
            }
            .empty-text {
                line-height: 22px;
                margin-top: 8px;
                color: #4E5969;
            }
        }
    }
    .pagination {
        text-align: right;
        margin-top: 16px;
    }
}
</style>
